export default {
  phone: '@media only screen and (max-width: 767px)',
  tablet: '@media only screen and (min-width: 768px)',
  webkit: '@media screen and (-webkit-min-device-pixel-ratio: 0)',
};
